import { makeStyles } from "@material-ui/core";

const useSternumFlagStyles = makeStyles((theme) => {});

export default useSternumFlagStyles;
